export const stateClasses = {
  DELETED: 'deleted',
  TARGET: 'target',
  SELECTED: 'selected',
  DRAGGING: 'dragging',
  DEFAULT: 'pod',
} as const;
